import React from 'react';

const User: React.FC<{ strokeWidth?: number; stroke?: string; size?: number }> = ({ strokeWidth, stroke, size }) => (
  <svg width={size || '18'} height={size || '18'} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 9C11.0711 9 12.75 7.32107 12.75 5.25C12.75 3.17893 11.0711 1.5 9 1.5C6.92893 1.5 5.25 3.17893 5.25 5.25C5.25 7.32107 6.92893 9 9 9Z"
      stroke={stroke || '#898F98'}
      strokeWidth={strokeWidth || '1.5'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.4426 16.5C15.4426 13.5975 12.5551 11.25 9.00011 11.25C5.44511 11.25 2.55762 13.5975 2.55762 16.5"
      stroke={stroke || '#898F98'}
      strokeWidth={strokeWidth || '1.5'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default User;
